import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { withRouter } from 'react-router-dom';
import Responsive from "../Responsive";
import { checkTranslation, conditionalWidth, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import Modal from "../Modal";
import StagesManager from "../StagesManager";
import FormViewer from "../FormViewer";
import RoomControlComponent from "./RoomControlComponent";
import StickersView from "../views/messenger/StickersView";


class RoomControl extends React.Component {


  onShowWhiteboard = () => {
    this.props.onShowWhiteboard()
  }

  showSettingsModal = () => {
    this.settingsModal.showModal()
  }

  showHelpModal = () => {
    this.helpModal.showModal()
  }

  showAbuseModal = () => {
    this.abuseModal.showModal()
  }

  showProblemModal = () => {
    this.problemModal.showModal()
  }

  showChangeLayout = () => {
    this.layoutModal.showModal()
  }

  state = {
    more: [
      { key: "whiteboard", name: "{{lang}}rooms.Whiteboard", icon: "/assets/icons/rooms/whiteboard.svg", functionClick: this.onShowWhiteboard },
      { key: "layout", name: "{{lang}}rooms.Change layout", icon: "/assets/icons/rooms/layout.svg", functionClick: this.showChangeLayout },
      { key: "fullscreen", name: "{{lang}}rooms.Fullscreen", icon: "/assets/icons/rooms/fullscreen.svg", functionClick: this.createRoom },
      { key: "pictureInPicture", name: "{{lang}}rooms.Open picture-in-picture", icon: "/assets/icons/rooms/picture-in-picture.svg", functionClick: this.createRoom },
      { key: "visualEffects", name: "{{lang}}rooms.Apply visual effects", icon: "/assets/icons/rooms/effects.svg", functionClick: this.createRoom },
      // { key: "caption", name: "{{lang}}rooms.Turn on captions", icon: "/assets/icons/rooms/caption.svg", functionClick: this.createRoom },
      { key: "problem", name: "{{lang}}rooms.Report a problem", icon: "/assets/icons/rooms/problem.svg", functionClick: this.showProblemModal },
      { key: "abuse", name: "{{lang}}rooms.Report abuse", icon: "/assets/icons/rooms/abuse.svg", functionClick: this.showAbuseModal },
      { key: "help", name: "{{lang}}rooms.Help", icon: "/assets/icons/rooms/help.svg", functionClick: this.showHelpModal },
      { key: "settings", name: "{{lang}}rooms.Settings", icon: "/assets/icons/rooms/setting.svg", functionClick: this.showSettingsModal },
    ],
    settingsPage: [
      { key: 'audio', label: '{{lang}}rooms.Audio', icon: '/assets/icons/rooms/audio-purple.svg', },
      { key: 'video', label: '{{lang}}rooms.Video', icon: '/assets/icons/rooms/video-purple1.svg', },
      { key: 'general', label: '{{lang}}rooms.General', icon: '/assets/icons/rooms/setting.svg', },
      // { key: 'captions', label: '{{lang}}rooms.Captions', icon: '/assets/icons/rooms/caption.svg', },
      { key: 'reactions', label: '{{lang}}rooms.Reactions', icon: '/assets/icons/rooms/reaction-purple.svg', },
    ],
    currentPage: 'audio',
    micrhophoneHeaders: [{ key: 'micrhophone', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: '', },], label: '', placeholder: '{{lang}}rooms.Default', required: false } },],
    talkHeaders: [{ key: 'talk', type: 'SwitchInput', col: '12', information: { required: false } },],
    speakerHeaders: [{ key: 'speaker', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: '', },], label: '', placeholder: '{{lang}}rooms.Default', required: false } },],
    cameraHeaders: [{ key: 'camera', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: '', },], label: '', placeholder: '{{lang}}rooms.Default', required: false } },],
    lightingHeaders: [{ key: 'lighting', type: 'SwitchInput', col: '12', information: { required: false } },],
    sendResolutionHeaders: [{ key: 'sendResolution', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: '', },], label: '', placeholder: '{{lang}}rooms.Auto', required: false } },],
    recieveResolutionHeaders: [{ key: 'recieveResolution', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: '', },], label: '', placeholder: '{{lang}}rooms.Auto', required: false } },],
    additionalHeaders: [{ key: 'additional', type: 'SwitchInput', col: '12', information: { required: false } },],
    leaveHeaders: [{ key: 'leave', type: 'SwitchInput', col: '12', information: { required: false } },],
    captionHeaders: [{ key: 'caption', type: 'SwitchInput', col: '12', information: { required: false } },],
    languageHeaders: [{ key: 'language', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: '', },], label: '', placeholder: '{{lang}}rooms.English', required: false } },],
    reactionsHeaders: [{ key: 'reactions', type: 'SwitchInput', col: '12', information: { required: false } },],
    animationHeaders: [{ key: 'animation', type: 'SwitchInput', col: '12', information: { required: false } },],
    soundReactionsHeaders: [{ key: 'soundReactions', type: 'SwitchInput', col: '12', information: { required: false } },],
    helpPage: [
      // { key: 'troubleshooting', label: 'Troubleshooting', icon: '/assets/icons/rooms/troubleshooting.svg', },
      { key: 'help', label: '{{lang}}rooms.Help', icon: '/assets/icons/rooms/help.svg', },
    ],
    helpItems: [
      {
        name: '{{lang}}rooms.How to use Room', items: [
          { name: '{{lang}}rooms.Present during a video room' },
          { name: '{{lang}}rooms.Record a video room' },
          { name: '{{lang}}rooms.Live stream a video room' },
          { name: '{{lang}}rooms.Change your background' },
        ]
      },
      {
        name: '{{lang}}rooms.Troubleshoot issues with Room', items: [
          { name: '{{lang}}rooms.Present your screen & camera issues' },
          { name: '{{lang}}rooms.Video and audio quality' },
          { name: '{{lang}}rooms.Requirements for using Room' },
        ]
      },
    ],
    abuseHeaders: [
      { key: 'abuseType', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: '', },], label: '{{lang}}rooms.Abuse type', placeholder: '{{lang}}rooms.Default', required: true } },
      { key: 'abuserName', type: 'TextInput', col: '12', information: { required: true, label: '{{lang}}rooms.Full names of abusers' } },
      { key: 'describe', type: 'TextAreaInput', col: '12', information: { required: true, label: '{{lang}}rooms.Describe your issues' } },
    ],
    layoutHeaders: [
      { key: 'layout', type: 'RoomChangeLayout', col: '12', information: { type: "local", items: [{ title: '{{lang}}rooms.Auto', img: '/assets/icons/rooms/auto-layout.svg', width: 80 }, { title: '{{lang}}rooms.Tiled', img: '/assets/icons/rooms/tiled-layout.svg', width: 80 }, { title: '{{lang}}rooms.Spotlight', img: '/assets/icons/rooms/spotlight-layout.svg', width: 80 }, { title: '{{lang}}rooms.Sidebar', img: '/assets/icons/rooms/sidebar-layout.svg', width: 80 },], label: '', placeholder: '{{lang}}rooms.Default', required: false } },
    ],
  }

  componentDidMount() {

    setTimeout(() => {
      this.setState({ showFixedViews: true })
    }, 100);
    // let path = window.location.pathname
    // path = path.split('/')[-1]
    // // console.log(path)
    // this.setState({ path })
  }

  // turn video on or off
  // onOffVideo = async () => {
  //   // this.props.onOffVideo(()=>{
  //   // })
  //   // console.log('this.props.peerConnectionCon', this.props.peerConnections)
  //   // this.props.peerConnection.getSenders().forEach(sender => {
  //   //   console.log(sender.track.kind + ' pause');//audio(if it exists) and video
  //   //   const parameters = sender.getParameters();
  //   //   parameters.encodings[0].active = false;
  //   //   sender.setParameters(parameters);
  //   // });


  //   if (!this.props.videoOff) {
  //     // console.log('before this.props.stream', this.props.stream)
  //     // Object.values(this.props.peerConnections).map((element) => {
  //     //   element.getSenders().forEach(sender => {
  //     //     console.log(sender.track.kind + ' pause');//audio(if it exists) and video
  //     //     const parameters = sender.getParameters();
  //     //     parameters.encodings[0].active = false;
  //     //     sender.setParameters(parameters);
  //     //   });
  //     // })
  //     this.props.stream.getVideoTracks().forEach(track => {
  //       track.pause()
  //     });
  //   }
  //   else {
  //     // Object.values(this.props.peerConnections).map((element) => {
  //     //   element.getSenders().forEach(sender => {
  //     //     console.log(sender.track.kind + ' resume');
  //     //     const parameters = sender.getParameters();
  //     //     parameters.encodings[0].active = true;
  //     //     sender.setParameters(parameters);
  //     //   });
  //     // })

  //     navigator.mediaDevices.getUserMedia({
  //       video: true
  //     }).then(async (stream) => {
  //       // console.log('after this.props.stream', this.props.stream)
  //       // await this.props.stream.replaceTrack(stream.getVideoTracks()[0]);

  //       await this.props.stream.removeTrack(this.props.stream.getVideoTracks()[0])
  //       await this.props.stream.addTrack(stream.getVideoTracks()[0])
  //     })
  //   }
  //   let videoOff = this.props.videoOff
  //   videoOff = !videoOff
  //   this.props.setData('videoOff', videoOff)
  //   // this.setState({ video: !this.state.video })

  // }

  // turn audio on or off
  toggleMuteAudio = () => {
    // this.props.stream.getAudioTracks()[0].enabled = !(this.props.stream.getAudioTracks()[0].enabled)
    // // this.setState({ audio: !this.state.audio })
    // let micOff = this.props.micOff
    // micOff = !micOff
    // this.props.setData('micOff', micOff)
    this.props.toggleMuteAudio()
  }


  toggleStopCamera = () => {
    this.props.toggleStopCamera()
  }

  toggleRaiseHand=()=>{
    this.props.toggleRaiseHand()
  }


  changePage = (item) => {
    this.stageManager.changeStage(item.key)
    this.setState({ currentPage: item.key })
  }



  render() {
    let checked = {}
    if (this.props.checked) {
      checked = this.props.checked
    } else {
      checked['layout'] = this.state.layoutHeaders[0].information?.items[0]
    }
    return (
      <div className="">
        <div className=' position-fixed bottom-0 shadow-2 br-10 p-2 control-bg' style={{ zIndex: 10, width: 'calc( 100% - 70px )', margin: '10px' }}>
          <div className='flexcb' style={{}}>
            <div>
              <div className="room-button" onClick={() => this.props.setInformation()} >
                <img width={22} src="/assets/icons/rooms/info.svg" alt="" />
              </div>
            </div>
            <div className={conditionalWidth(this.props.width, { xs: ' flexcb', 400: ' group-btn ' })}>

              <div className={"flexcc room-button "} onClick={() => this.props.screenShare()} style={{ backgroundColor: (this.props.isScreenStreaming ? '#FF3B30' : null) }} >
                <img width={21} src="/assets/icons/rooms/share-screen.svg" />
              </div>

              {this.props.useAudio ? (
                <div className="room-button" onClick={() => this.toggleMuteAudio()}>
                  <img width={22} src="/assets/icons/rooms/mic.svg" alt="" />
                </div>) : (
                <div className="room-button" style={{ backgroundColor: '#FF3B30' }} onClick={() => this.toggleMuteAudio()}>
                  <img width={22} src="/assets/icons/rooms/mic-off.svg" alt="" />
                </div>)}

              {this.props.useVideo ?
                <div className="room-button" onClick={() => this.toggleStopCamera()}>
                  <img width={22} src="/assets/icons/rooms/video.svg" alt="" />
                </div> :
                <div className="room-button" style={{ backgroundColor: '#FF3B30' }} onClick={() => this.toggleStopCamera()}>
                  <img width={22} src="/assets/icons/rooms/video-off.svg" alt="" />
                </div>
              }

              <div className="dial flexcc cursor-pointer mx-3" style={{}} onClick={() => this.props.leaveRoom()}>
                <img src="/assets/icons/rooms/dial.svg" alt="" />
              </div>

              <div className={conditionalWidth(this.props.width, { xs: ' d-none ', 700: ' d-flex ' })}>
                <StickersView onSelect={this.props.onStickerSelect} type='room' />
              </div>

              <div className={"flexcc " + (!this.props.myHandStatus ? 'room-button' : 'room-button-active')} onClick={() => this.toggleRaiseHand()}>
                <img width={22} className="" src="/assets/icons/rooms/hand.svg" alt="" />
              </div>

              <div className="flexcc room-button" ref={el => this.moreNodeRef = el} onClick={() => { this.moreFixedView.showView() }} >
                <img width={22} className="" src="/assets/icons/rooms/more.svg" alt="" />
              </div>
            </div>

            <div className={conditionalWidth(this.props.width, { xs: ' d-none ', 445: ' d-block ' })}>
              <div className="flexc">
                <div className="flexcc room-button" onClick={() => this.props.onShowWhiteboard()}>
                  <img width={22} src="/assets/icons/rooms/whiteboard-white.svg" alt="" />
                </div>
                <div className="flexcc room-button" onClick={() => this.props.showHubsList()}>
                  <img width={21} src="/assets/icons/rooms/members.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.showFixedViews && (
          <FixedView ref={el => this.moreFixedView = el} width={this.props.width} nodeRef={this.moreNodeRef} zIndex={1000} bottomOffset={30} topOffset={0} maxWidth={240}>
            <div className='sc-1 shadow-2 br-10 py-1 px-2' style={{ backgroundColor: "#fff", }}>
              {this.state.more.map((prop, index) => {
                return (
                  <div className="bb-gray mt-1 pb-1" key={prop.key} >
                    <button className='px-2 flexc hover-gray py-2 br-10 w-100 h-100' onClick={() => { prop["functionClick"]() }}>
                      <img width={22} className="mrd-1" src={prop.icon} />
                      <p className='font-size-14 main-c7 mld-2'>{checkTranslation(prop.name)}</p>
                    </button>
                  </div>
                )
              })}
            </div>
          </FixedView>
        )}
        <Modal maxWidth={600} maxHeight={400} className="" ref={(e) => this.settingsModal = e}  >
          <div className="settingsModal w-100 d-flex flex-row w-100 " style={{ overflow: 'hidden', backgroundColor: '#F5F5F5', height: '400px' }} >
            <div className="window-content-radius" style={{ width: '35%' }}>
              <div className='scroll-no-scrollbar h-100 w-100 d-flex flex-column' style={{ backgroundColor: "#fff", borderRight: '1px solid #eee' }}>
                <div className='flexc p-2 position-sticky top-0' style={{}}>
                  <div className='mld-2'>
                    <p className="font-size-20 weight-700 pt-2" style={{ color: "#333" }} >{translate('rooms.Settings')}</p>
                  </div>
                </div>
                <div className=' w-100'>
                  {this.state.settingsPage.map((item, index) => {
                    return (
                      <div className='w-100 prd-2' key={index}>
                        <button onClick={() => this.changePage(item)} className={' pt-2 pb-2 px-3 br-10 w-100 ' + (this.state.currentPage == item.key ? '' : 'hover-purple')} style={{ backgroundColor: this.state.currentPage == item.key ? '#f6f6f6' : '', borderTopRightRadius: this.props.language == 'fa' ? '' : '100px', borderBottomRightRadius: this.props.language == 'fa' ? '' : '100px', borderTopLeftRadius: this.props.language == 'fa' ? '100px' : '', borderBottomLeftRadius: this.props.language == 'fa' ? '100px' : '' }}>
                          <div className='flexc'>
                            <img className='mrd-3' src={item.icon} height={30} style={{}} />
                            <p className='text-start font-size-15 weight-500' style={{ color: "#333" }}>{checkTranslation(item.label)}</p>
                          </div>
                        </button>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            <div className="window-content-radius" style={{ width: '65%' }}>
              <div className=' w-100 h-100 d-flex scroll-no-scrollbar window-content-radius px-4' style={{ backgroundColor: '#f6f6f6' }}>
                <StagesManager ref={el => this.stageManager = el} height={'100%'}>
                  <div stage={this.state.currentPage == 'audio' ? 0 : 1} stageName={'audio'} className="py-3 h-100 scroll-no-scrollbar" >
                    <RoomControlComponent padding={'pt-2'} name={'{{lang}}rooms.Microphone'} headers={this.state.micrhophoneHeaders} img={"/assets/icons/rooms/mic-purple.svg"} />
                    <RoomControlComponent padding={'py-2'} name={'{{lang}}rooms.Push to talk'} description={'{{lang}}rooms.Press and hold spacebar to unmute your mic'} headers={this.state.talkHeaders} />
                    <RoomControlComponent padding={'py-2'} name={'{{lang}}rooms.Speakers'} headers={this.state.speakerHeaders} img={"/assets/icons/rooms/speaker-purple.svg"} />
                  </div>

                  <div stage={this.state.currentPage == 'video' ? 0 : 1} stageName={'video'} className="py-3 h-100 scroll-no-scrollbar" >
                    <RoomControlComponent padding={'pt-2'} name={'{{lang}}rooms.Camera'} headers={this.state.cameraHeaders} localMediaStream={this.props.localMediaStream} />
                    <RoomControlComponent padding={'py-2'} name={'{{lang}}rooms.Adjust video lighting'} description={'{{lang}}rooms.Make it easier to see you against a bright background'} headers={this.state.lightingHeaders} />
                    <RoomControlComponent padding={'py-2'} name={'{{lang}}rooms.Send resolution (maximum)'} headers={this.state.sendResolutionHeaders} />
                    <RoomControlComponent padding={'pb-2'} name={'{{lang}}rooms.Receive resolution (maximum)'} headers={this.state.recieveResolutionHeaders} />
                  </div>

                  <div stage={this.state.currentPage == 'general' ? 0 : 1} stageName={'general'} className="py-3 h-100 scroll-no-scrollbar" >
                    <RoomControlComponent padding={'py-2'} name={'{{lang}}rooms.Send additional diagnostic info to Yonnect'} description={'{{lang}}rooms.Yonnect uses these system logs to make Meet better everyone'} headers={this.state.additionalHeaders} />
                    <RoomControlComponent padding={'pt-3'} name={'{{lang}}rooms.Leave empty calls'} description={'{{lang}}rooms.Removes you from a call after a few minutes if no one else joins'} headers={this.state.leaveHeaders} />
                  </div>

                  <div stage={this.state.currentPage == 'captions' ? 0 : 1} stageName={'captions'} className="py-3 h-100 scroll-no-scrollbar" >
                    <RoomControlComponent padding={'py-2'} name={'{{lang}}rooms.Captions'} description={'{{lang}}rooms.Select the language people will use in the room. Captions will be displayed in this language except when translation is turned on'} headers={this.state.captionHeaders} />
                    <RoomControlComponent padding={'py-2'} name={'{{lang}}rooms.Language of the room'} headers={this.state.languageHeaders} />
                  </div>

                  <div stage={this.state.currentPage == 'reactions' ? 0 : 1} stageName={'reactions'} className="py-3 h-100 scroll-no-scrollbar">
                    <RoomControlComponent padding={'py-2'} name={'{{lang}}rooms.Show reactions from others'} description={'{{lang}}rooms.When off, your own reactions still appear'} headers={this.state.reactionsHeaders} />
                    <RoomControlComponent padding={'py-2'} name={'{{lang}}rooms.Animations'} description={'{{lang}}rooms.Reactions move on the screen'} headers={this.state.animationHeaders} />
                    <RoomControlComponent padding={'py-2'} name={'{{lang}}rooms.Sound'} description={'{{lang}}rooms.Sound can accompany reactions'} headers={this.state.soundReactionsHeaders} />
                  </div>
                </StagesManager>
              </div>
            </div>
          </div>
        </Modal >

        <Modal maxWidth={600} height={'200px'} className="" ref={(e) => this.helpModal = e}  >
          <div className="settingsModal w-100 h-100 d-flex flex-row w-100 " style={{ overflow: 'hidden', backgroundColor: '#F5F5F5', }} >
            <div className="window-content-radius" style={{ width: '35%' }}>
              <div className='scroll-no-scrollbar h-100 w-100 d-flex flex-column' style={{ backgroundColor: "#fff", borderRight: '1px solid #eee' }}>
                <div className='flexc p-2 position-sticky top-0' style={{}}>
                  <p className="mld-2 font-size-20 weight-700 pt-2" style={{ color: "#333" }} >{translate('rooms.Help')}</p>
                </div>
                <div className=' w-100'>
                  {this.state.helpPage.map((item, index) => {
                    return (
                      <div className='w-100 prd-2' key={index}>
                        <button onClick={() => this.changePage(item)} className={' pt-2 pb-2 px-3 br-10 my-1 w-100 ' + (this.state.currentPage == item.key ? '' : 'hover-purple')} style={{ backgroundColor: this.state.currentPage == item.key ? '#f6f6f6' : '', borderTopRightRadius: this.props.language == 'fa' ? '' : '100px', borderBottomRightRadius: this.props.language == 'fa' ? '' : '100px', borderTopLeftRadius: this.props.language == 'fa' ? '100px' : '', borderBottomLeftRadius: this.props.language == 'fa' ? '100px' : '' }}>
                          <div className='flexc'>
                            <img className='mrd-3' src={item.icon} height={30} style={{}} />
                            <p className='text-start font-size-15 weight-500' style={{ color: "#333" }}>{checkTranslation(item.label)}</p>
                          </div>
                        </button>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            <div className="window-content-radius" style={{ width: '65%' }}>
              <div className=' w-100 h-100 d-flex scroll-no-scrollbar window-content-radius' style={{ backgroundColor: '#f6f6f6' }}>
                <StagesManager ref={el => this.stageManager = el} height={'100%'}>
                  {/* <div stage={0} stageName={'troubleshooting'} className="py-3 h-100 scroll-no-scrollbar" >
                  </div> */}

                  <div stage={0} stageName={'help'} className="pt-3 h-100 scroll-no-scrollbar" >
                    <div className="w-100 px-3 py-2">
                      <div className="w-100 px-1 flexcb py-1 br-10 bg-white">
                        <img src='/assets/icons/rooms/search.svg' width={20} />
                        <input className='roomScheduleUrl w-100 font-size-14 weight-200 px-1 py-1 mx-1' placeholder={translate('rooms.Search Help Center')} />
                      </div>
                    </div>
                    {this.state.helpItems.map((item, index) => {
                      return (
                        <div className="py-2 pt-3 px-3" key={index}>
                          <p className="font-size-15 pb-3">{checkTranslation(item.name)}</p>
                          {item.items.map((prop, index) => {
                            return (
                              <div className="flexc pb-2" key={index}>
                                <img src="/assets/icons/rooms/text-purple.svg" />
                                <p className="font-size-14 main-c7 pld-2">{checkTranslation(prop.name)}</p>
                              </div>
                            )
                          })}
                        </div>
                      )
                    })}
                    <div className="w-100 bb-gray px-3">
                      <p className="font-size-14 weight-500 pb-3" style={{ color: '#7064FE' }}>{translate('rooms.See all help articles')}</p>
                    </div>
                    <p className="font-size-14 weight-500 py-3 px-3" style={{ color: '#7064FE' }}>{translate('rooms.Community')}</p>
                  </div>
                </StagesManager>
              </div>
            </div>
          </div>
        </Modal >

        <Modal maxWidth={400} className="" ref={(e) => this.abuseModal = e}  >
          <div className="settingsModal w-100 h-100 scroll-no-scrollbar flexcb flex-column w-100 " style={{ overflow: 'hidden', backgroundColor: '#F5F5F5', height: '400px' }} >
            <div className="w-100 px-4 py-3 flexcb">
              <button onClick={() => { this.abuseModal.hideModal() }}>
                <p className="font-size-15 weight-500" style={{ color: '#7064FE' }}>{translate('rooms.Close')}</p>
              </button>
              <button>
                <p className="font-size-15 weight-500" style={{ color: '#7064FE' }}>{translate('rooms.Report')}</p>
              </button>
            </div>
            <div className="px-3 w-100 scroll-no-scrollbar" style={{}}>
              <p className='font-size-15 weight-500 pb-2 px-3'>{translate('rooms.Report abuse')}</p>
              <p className='font-size-14 px-3 pb-1' style={{ color: 'rgb(95,99,104)' }}>{translate('rooms.Identify-the-people-in-this-room')}</p>
              <div className="py-2">
                <div className="flexcb w-100">
                  <FormViewer ref={el => this.form = el} headers={this.state.abuseHeaders} theme={"modern"} inputClass={"modern-input5"} />
                </div>
              </div>
            </div>
          </div>
        </Modal >

        <Modal maxWidth={400} height={'170px'} className="" ref={(e) => this.problemModal = e}  >
          <div className="settingsModal w-100 scroll-no-scrollbar flexcb flex-column w-100 " style={{ overflow: 'hidden', backgroundColor: '#F5F5F5', }} >
            <div className="px-3 pt-4 w-100 " style={{}}>
              <p className='font-size-14 px-3' style={{ color: 'rgb(95,99,104)' }}>{translate('rooms.If-there-was-a-problem')}</p>
            </div>
            <div className="w-100 px-4 py-3 flexcb">
              <button onClick={() => { this.problemModal.hideModal() }}>
                <p className="font-size-15 weight-500" style={{ color: '#7064FE' }}>{translate('rooms.Deny')}</p>
              </button>
              <button>
                <p className="font-size-15 weight-500" style={{ color: '#7064FE' }}>{translate('rooms.Allow')}</p>
              </button>
            </div>
          </div>

        </Modal >

        <Modal maxWidth={300} className="" ref={(e) => this.layoutModal = e}  >
          <div className="settingsModal w-100 scroll-no-scrollbar flexcb flex-column w-100 " style={{ overflow: 'hidden', backgroundColor: '#F5F5F5', }} >
            <div className="px-3 pt-4 w-100 scroll-no-scrollbar" style={{}}>
              <p className='font-size-15 weight-500 pb-2 px-3'>{translate('rooms.Change layout')}</p>
              <p className='font-size-14 px-3' style={{ color: 'rgb(95,99,104)' }}>{translate('rooms.Selection is saved for future meetings')}</p>
              <FormViewer ref={el => this.form = el} initData={checked} liveChange={this.props.setLayout} headers={this.state.layoutHeaders} theme={"modern"} inputClass={"modern-input2"} />
            </div>
          </div>
        </Modal >
      </div >
    );
  }


}



const mapStateToProps = state => ({ settings: state.settings, cart: state.cart, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RoomControl));
